import { Navigate, Route, Routes } from 'react-router-dom'
import { Shell } from './components/Shell.tsx'
import { AyatPage } from './features/ayat/AyatPage.tsx'
import { ConsentPage } from './features/auth/ConsentPage.tsx'
import { PublicOnly, RequireOnboarding, RequireSession, RequireTerms } from './features/auth/Guards.tsx'
import { LegalPage } from './features/auth/LegalPage.tsx'
import { LoginPage } from './features/auth/LoginPage.tsx'
import { CeritaPage } from './features/cerita/CeritaPage.tsx'
import { HomePage } from './features/home/HomePage.tsx'
import { KotakPage } from './features/mutiara/KotakPage.tsx'
import { MutiaraPage } from './features/mutiara/MutiaraPage.tsx'
import { OnboardingPage } from './features/onboarding/OnboardingPage.tsx'
import { PlanPage } from './features/onboarding/PlanPage.tsx'
import { PeganganHome } from './features/pegangan/PeganganHome.tsx'
import { PeganganPage } from './features/pegangan/PeganganPage.tsx'
import { JumatPage } from './features/perjalanan/JumatPage.tsx'
import { KompasPage } from './features/perjalanan/KompasPage.tsx'
import { MuhasabahPage } from './features/perjalanan/MuhasabahPage.tsx'
import { NiatPage } from './features/perjalanan/NiatPage.tsx'
import { PerjalananPage } from './features/perjalanan/PerjalananPage.tsx'
import { RencanaPage } from './features/perjalanan/RencanaPage.tsx'
import { TantanganDayPage, TantanganListPage, TantanganProgramPage } from './features/perjalanan/TantanganPages.tsx'
import { QuranHome } from './features/quran/QuranHome.tsx'
import { SurahPage } from './features/quran/SurahPage.tsx'
import { BantuanPage } from './features/settings/BantuanPage.tsx'
import { SettingsPage } from './features/settings/SettingsPage.tsx'

/** Route table. Kept separate from the router so tests can mount it in a MemoryRouter. */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/legal/:doc" element={<LegalPage />} />

      <Route element={<PublicOnly />}>
        <Route path="/masuk" element={<LoginPage />} />
      </Route>

      <Route element={<RequireSession />}>
        <Route path="/mulai/setuju" element={<ConsentPage />} />
        <Route element={<RequireTerms />}>
          <Route path="/mulai" element={<OnboardingPage />} />
          <Route path="/mulai/rencana" element={<PlanPage />} />
          <Route element={<RequireOnboarding />}>
            <Route element={<Shell />}>
              <Route index element={<HomePage />} />
              <Route path="mutiara" element={<MutiaraPage />} />
              <Route path="mutiara/kotak" element={<KotakPage />} />
              <Route path="perjalanan" element={<PerjalananPage />} />
              <Route path="perjalanan/muhasabah" element={<MuhasabahPage />} />
              <Route path="perjalanan/niat" element={<NiatPage />} />
              <Route path="perjalanan/tantangan" element={<TantanganListPage />} />
              <Route path="perjalanan/tantangan/:id" element={<TantanganProgramPage />} />
              <Route path="perjalanan/tantangan/:id/:hari" element={<TantanganDayPage />} />
              <Route path="perjalanan/kompas" element={<KompasPage />} />
              <Route path="perjalanan/jumat" element={<JumatPage />} />
              <Route path="perjalanan/rencana" element={<RencanaPage />} />
              <Route path="quran" element={<QuranHome />} />
              <Route path="quran/:surah" element={<SurahPage />} />
              <Route path="cerita" element={<CeritaPage />} />
              <Route path="ayat/:day/:tahap?" element={<AyatPage />} />
              <Route path="pegangan" element={<PeganganHome />} />
              <Route path="pegangan/:id" element={<PeganganPage />} />
              <Route path="pengaturan" element={<SettingsPage />} />
              <Route path="bantuan" element={<BantuanPage />} />
            </Route>
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
